import React, { useState } from "react";
import { X, Plus } from "lucide-react";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

export default function SkillsSection({ draft, setDraft }) {
  const [input, setInput] = useState("");

  const addSkill = () => {
    const val = input.trim();
    if (val && !draft.skills.includes(val)) {
      setDraft({ ...draft, skills: [...draft.skills, val] });
    }
    setInput("");
  };

  const removeSkill = (skill) => setDraft({ ...draft, skills: draft.skills.filter((s) => s !== skill) });

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-skills">
      <p className="text-sm font-semibold text-white mb-3">Skills</p>
      <div className="flex gap-2 mb-3">
        <input
          value={input} onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addSkill())}
          placeholder="Type a skill and press Enter (e.g. Data Cloud)" data-testid="resume-skill-input"
          className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400"
        />
        <button onClick={addSkill} data-testid="resume-add-skill-button" className="flex items-center gap-1 bg-white/10 hover:bg-white/15 text-white text-xs font-semibold px-3 py-2 rounded-lg transition-colors">
          <Plus className="w-3.5 h-3.5" /> Add
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mb-3" data-testid="resume-skills-list">
        {draft.skills.map((skill) => (
          <span key={skill} className="flex items-center gap-1.5 text-xs font-medium bg-indigo-400/10 border border-indigo-400/30 text-indigo-300 rounded-full px-3 py-1" data-testid={`resume-skill-chip-${skill}`}>
            {skill}
            <button onClick={() => removeSkill(skill)} data-testid={`resume-remove-skill-${skill}`}><X className="w-3 h-3" /></button>
          </span>
        ))}
      </div>
      <AiPromptGenerator section="skills" draft={draft} setDraft={setDraft} />
    </div>
  );
}
